import { render } from "./FormInputSection.vue?vue&type=template&id=135536e0&scoped=true"
import script from "./FormInputSection.vue?vue&type=script&lang=js"
export * from "./FormInputSection.vue?vue&type=script&lang=js"

import "./FormInputSection.vue?vue&type=style&index=0&id=135536e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135536e0"]])

export default __exports__